import { useNavigate } from "react-router-dom";
import { Box, Grid, Typography, Avatar } from "@mui/material";
import CasinoRoundedIcon from "@mui/icons-material/CasinoRounded";
import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";
import LocalFireDepartmentRoundedIcon from "@mui/icons-material/LocalFireDepartmentRounded";
import CampaignRoundedIcon from "@mui/icons-material/CampaignRounded";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import { tokens } from "../../theme";

const CARDS = [
  {
    label: "WOF Configuration",
    desc: "Configure the Wheel of Fortune rewards and odds",
    icon: CasinoRoundedIcon,
    color: tokens.primary,
    path: "/wheel-of-fortune",
  },
  {
    label: "Monthly Promotions",
    desc: "Schedule and manage monthly promotional offers",
    icon: CalendarMonthRoundedIcon,
    color: tokens.accent,
    path: "/monthly-promotions",
  },
  {
    label: "Streak Types",
    desc: "Define daily login streaks and their rewards",
    icon: LocalFireDepartmentRoundedIcon,
    color: tokens.secondary,
    path: "/streak-types",
  },
  {
    label: "User Popup",
    desc: "Create marketing pop-ups shown to players",
    icon: CampaignRoundedIcon,
    color: tokens.blue,
    path: "/MarketingPopup",
  },
];

const PromotionNavigation = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ px: { xs: 0.5, sm: 1 }, py: 1 }}>
      <Typography variant="h4" sx={{ mb: 0.5 }}>
        Promotion Control Panel
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Select a promotion module to configure
      </Typography>

      <Grid container spacing={2.25}>
        {CARDS.map((c) => {
          const Icon = c.icon;
          return (
            <Grid item xs={12} sm={6} md={3} key={c.label}>
              <Box
                role="button"
                tabIndex={0}
                onClick={() => navigate(c.path)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") navigate(c.path);
                }}
                sx={{
                  height: "100%",
                  p: 2.5,
                  borderRadius: "14px",
                  cursor: "pointer",
                  position: "relative",
                  overflow: "hidden",
                  background: tokens.cardBg,
                  border: `1px solid ${tokens.border}`,
                  transition: "transform .15s ease, border-color .15s ease, box-shadow .15s ease",
                  "&:hover": {
                    transform: "translateY(-3px)",
                    borderColor: c.color,
                    boxShadow: `0 10px 28px rgba(0,0,0,0.45)`,
                    "& .arrow": { opacity: 1, transform: "translateX(0)" },
                  },
                  "&:focus-visible": { outline: `2px solid ${c.color}`, outlineOffset: 2 },
                }}
              >
                {/* accent top bar */}
                <Box sx={{ position: "absolute", top: 0, left: 0, right: 0, height: 3, bgcolor: c.color }} />
                <Avatar
                  variant="rounded"
                  sx={{
                    width: 52,
                    height: 52,
                    borderRadius: "12px",
                    mb: 2,
                    bgcolor: `${c.color}22`,
                    color: c.color,
                  }}
                >
                  <Icon />
                </Avatar>
                <Typography
                  sx={{
                    fontFamily: '"Space Grotesk", sans-serif',
                    fontWeight: 600,
                    fontSize: 16,
                    mb: 0.5,
                  }}
                >
                  {c.label}
                </Typography>
                <Typography variant="caption" color="text.secondary" sx={{ display: "block", lineHeight: 1.5 }}>
                  {c.desc}
                </Typography>
                <ArrowForwardRoundedIcon
                  className="arrow"
                  sx={{
                    position: "absolute",
                    right: 16,
                    bottom: 16,
                    fontSize: 18,
                    color: c.color,
                    opacity: 0,
                    transform: "translateX(-6px)",
                    transition: "opacity .15s ease, transform .15s ease",
                  }}
                />
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default PromotionNavigation;
